import { Component, inject, OnInit } from '@angular/core';
import { DxButtonComponent } from 'devextreme-angular';
import { Articoli } from 'src/app/models/articoli';
import { GridArchivioArticoliComponent } from 'src/app/shared/components/articoli/grid-archivio-articoli/grid-archivio-articoli.component';
import { FiltroButtonCategorieArticoliComponent } from 'src/app/shared/components/filtri/filtro-button-categorie-articoli/filtro-button-categorie-articoli.component';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ConvertError } from 'src/app/utils/gestione-errori';

@Component({
  selector: 'app-articoli',
  templateUrl: './articoli.component.html',
  styleUrls: ['./articoli.component.scss'],
  imports: [
    GridArchivioArticoliComponent,
    DxButtonComponent,
    FiltroButtonCategorieArticoliComponent,
  ],
})
export class ArticoliComponent implements OnInit {
  private articoliS = inject(ArticoliService);
  private navigateService = inject(NavigatorService);
  categoriaRif: number = 0;
  listArticoli: Articoli[] = [];

  articoliAttivi: boolean = true;

  ngOnInit() {
    this.loadArticoli();
  }

  filterGrid(e: any) {
    this.categoriaRif = e;
  }

  loadArticoli() {
    this.articoliS.list(false).subscribe({
      next: (res) => {
        if (res != null) {
          this.listArticoli = res;
        }
      },
      error: (error) => {
        ConvertError(error, 'Errore recupro articoli');
      },
    });
  }

  goToArticoloNew() {
    this.navigateService.goToArticoliNew();
  }

  onArticoliAttiviEventEmitter(e: boolean){
    this.articoliAttivi = e;
  }
}
